<router-outlet></router-outlet>
<p-toast *ngIf="showToaster$ | async" position="bottom-right" [style]="{marginTop: '80px'}"></p-toast>
